import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { pickQueryParams } from './parseQueryString';

/**
 * 입력받은 키 목록에 해당하는 쿼리 파라미터 객체(파싱된 쿼리 스트링)를 상태로 사용합니다.
 * [TIP] 타입스크립트 Enum 객체를 넣으면 완전한 타입 지원이 가능합니다.
 * @param keys 문자열 배열 혹은 타입스크립트 Enum 객체
 * @returns 쿼리 파라미터 객체(레코드)
 */
export default function useQueryParams<T extends string>(keys: T[]) {
  const location = useLocation();

  const [params, setParams] = useState(() => pickQueryParams<T>(keys));

  useEffect(() => {
    setParams(pickQueryParams(keys));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return params;
}
